import axios from 'axios';

// import { getCurrentLanguage } from "@/helpers/AppHelpers";

export default {
  getCedListeLive() {
    return axios
      .get('/json/casino-en-direct/table-liste-live', {
        // params: {
        //   lang: getCurrentLanguage(),
        // },
      })
      .then((response) => {
        return response.data;
      });
  },
};
